import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { AppService } from 'src/_services/app.service';
import { betsMap } from 'src/_constants/sampledoc'
import { AuthenticationService } from 'src/_services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-db-collection',
  templateUrl: './db-collection.component.html',
  styleUrls: ['./db-collection.component.scss']
})
export class DbCollectionComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  selectedBetId = "";
  sampleDocs = betsMap
  length: any = 0;
  collectionName = new FormControl([]);
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  displayTableColumns = [
    "s.no",
    "documents"
  ];
  query = "";
  collectionList = [
    {id:"markets",name:"MarketCollection"},
    {id:"bets",name:"BetCollection"},
    {id:"events",name:"EventCollection"},
  ];
  dropdownSettings: any = {};
  data = [];

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  getRecords() {
    try {
      let filters = {
        collection: this.collectionName.value.length !== 0 ? this.collectionName.value[0].id : "",
        query: this.query,
        page: this.page,
        pageSize: this.orgPageSize,
      }
   
    this.appService
      .getDbReports(filters)
      .subscribe((response) => {
        if (response.status === "RS_OK") {
          if (this.page == 1) {
            this.length = response.totalCount;
          }
          this.data = response.data
        } else {
          this.authenticationService.openErrorSnackBar(response.errorDescription);
          if (response.errorDescription === "Invalid Token!") {
            this.router.navigateByUrl("/login");
            sessionStorage.clear();
          }
        }
      });
  } catch (err) {
    console.log(err);
  }
  }

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getRecords();
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getRecords();
  }

  onquery(value) {
    this.query = value.trim();
  }

  onqueryClear() {
    this.query = "";
  }

  getSampleDoc() {
    this.dialog.open(SampleDocComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        collection: this.collectionName.value[0].id ,
        doc: betsMap[this.collectionName.value[0].id],
      },
    });
  }

}

@Component({
  selector: 'dialog-data-example-dialog',
  templateUrl: './db-sample-doc.component.html',
  styleUrls: ['./db-collection.component.scss']
})
export class SampleDocComponent {

  data = [];
  constructor(@Inject(MAT_DIALOG_DATA) public Data: any,
    private appService: AppService) {
    if (Data) {
      this.data = Data;
    }
  }

  ngOnInit() {}
}